/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierQuotingRestriction,
  CarrierQuotingRestrictionHistory,
  CarrierQuotingRestrictionInput,
} from "../models/index";
import {
  CarrierQuotingRestrictionFromJSON,
  CarrierQuotingRestrictionToJSON,
  CarrierQuotingRestrictionHistoryFromJSON,
  CarrierQuotingRestrictionHistoryToJSON,
  CarrierQuotingRestrictionInputFromJSON,
  CarrierQuotingRestrictionInputToJSON,
} from "../models/index";

export interface DeleteCarrierRestrictionRequest {
  carrierQuotingRestrictionId: string;
}

export interface EditCarrierRestrictionRequest {
  carrierQuotingRestrictionInput: CarrierQuotingRestrictionInput;
}

export interface GetHistoryForIdRequest {
  carrierQuotingRestrictionId: string;
}

export interface InsertCarrierRestrictionRequest {
  carrierQuotingRestrictionInput: CarrierQuotingRestrictionInput;
}

/**
 *
 */
export class CarrierRestrictionsApi extends runtime.BaseAPI {
  /**
   */
  async deleteCarrierRestrictionRaw(
    requestParameters: DeleteCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierQuotingRestrictionId"] == null) {
      throw new runtime.RequiredError(
        "carrierQuotingRestrictionId",
        'Required parameter "carrierQuotingRestrictionId" was null or undefined when calling deleteCarrierRestriction().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierQuotingRestrictionId"] != null) {
      queryParameters["carrierQuotingRestrictionId"] =
        requestParameters["carrierQuotingRestrictionId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-restrictions/delete-carrier-restriction`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async deleteCarrierRestriction(
    requestParameters: DeleteCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteCarrierRestrictionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async editCarrierRestrictionRaw(
    requestParameters: EditCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierQuotingRestrictionInput"] == null) {
      throw new runtime.RequiredError(
        "carrierQuotingRestrictionInput",
        'Required parameter "carrierQuotingRestrictionInput" was null or undefined when calling editCarrierRestriction().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-restrictions/edit-carrier-restriction`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierQuotingRestrictionInputToJSON(
          requestParameters["carrierQuotingRestrictionInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async editCarrierRestriction(
    requestParameters: EditCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.editCarrierRestrictionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getAllCarrierRestrictionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierQuotingRestriction>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-restrictions/get-all-carrier-restrictions`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierQuotingRestrictionFromJSON),
    );
  }

  /**
   */
  async getAllCarrierRestrictions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierQuotingRestriction>> {
    const response = await this.getAllCarrierRestrictionsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getHistoryForIdRaw(
    requestParameters: GetHistoryForIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierQuotingRestrictionHistory>>> {
    if (requestParameters["carrierQuotingRestrictionId"] == null) {
      throw new runtime.RequiredError(
        "carrierQuotingRestrictionId",
        'Required parameter "carrierQuotingRestrictionId" was null or undefined when calling getHistoryForId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierQuotingRestrictionId"] != null) {
      queryParameters["carrierQuotingRestrictionId"] =
        requestParameters["carrierQuotingRestrictionId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-restrictions/history-for-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierQuotingRestrictionHistoryFromJSON),
    );
  }

  /**
   */
  async getHistoryForId(
    requestParameters: GetHistoryForIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierQuotingRestrictionHistory>> {
    const response = await this.getHistoryForIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertCarrierRestrictionRaw(
    requestParameters: InsertCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["carrierQuotingRestrictionInput"] == null) {
      throw new runtime.RequiredError(
        "carrierQuotingRestrictionInput",
        'Required parameter "carrierQuotingRestrictionInput" was null or undefined when calling insertCarrierRestriction().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-restrictions/insert-carrier-restriction`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierQuotingRestrictionInputToJSON(
          requestParameters["carrierQuotingRestrictionInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertCarrierRestriction(
    requestParameters: InsertCarrierRestrictionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertCarrierRestrictionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
